export const state = () => ({
  loading: false,
  eventLogs: {
    total: 0,
    totalPages: 0,
    data: []
  },
  eventLogCancelToken: {},
  eventLogsExcel: []
})

export const actions = {
  // Get all events
  async eventLogs({ commit, state }, data) {
    commit('setEventLogCancelToken', {
      eventLogs: this.$axios.CancelToken.source()
    })
    commit('setLoading', true)
    return await this.$axios
      .get(`/statistics/event-logs`, {
        params: data,
        cancelToken: state.eventLogCancelToken.eventLogs.token
      })
      .then(response => {
        commit('setEventLogs', response.data)
        commit('setLoading', false)
      })
      .catch(() => {
        commit('setLoading', false)
      })
  },
  async eventLogsExcel({ commit, state }, data) {
    return await this.$axios
      .get(`/statistics/event-logs/excel`, {
        params: data
      })
      .then(response => {
        commit('setEventLogsExcel', response.data)
        return response.data
      })
      .catch(() => {
        commit('setLoading', false)
        return false
      })
  }
}

export const mutations = {
  setLoading(state, type) {
    state.loading = type
  },
  setEventLogs(state, eventLogs) {
    state.eventLogs = eventLogs
  },
  setEventLogsExcel(state, eventLogs) {
    state.eventLogsExcels = eventLogs
  },
  setEventLogCancelToken: (state, data) => {
    const oldData = { ...state.eventLogCancelToken }
    state.eventLogCancelToken = {
      ...oldData,
      ...data
    }
  }
}
